import React, { useContext, useMemo } from 'react';
import SourceFilesInput from '../../modals/seller/form/SourceFilesInput/SourceFilesInput';
import { SubmitFormContext } from '../../context';

interface Props {
  className?: string;
}

const ExclusiveAttachmentsField: React.FC<Props> = ({ className }) => {
  const submitFormContext = useContext(SubmitFormContext);
  const { deviation, adoptable } = submitFormContext?.initResponse || {};
  const defaultValue = useMemo(
    () =>
      (adoptable?.assets || []).map(asset => ({
        name: asset.filename,
        size: asset.filesize,
        type: asset.type,
        deviationId: asset.isOriginal ? 0 : asset.deviationId,
        fileId: asset.fileId,
      })),
    [adoptable?.assets]
  );

  if (!deviation) {
    // should never get here
    return null;
  }

  return <SourceFilesInput deviation={deviation} defaultValue={defaultValue} />;
};
ExclusiveAttachmentsField.displayName = 'ExclusiveAttachmentsField';

export default ExclusiveAttachmentsField;
